export { DarkModeHandler, DARK_MODE_HANDLER_NAME } from './handler/darkModeHandler';
